export default __webpack_public_path__ + "static/media/bipolar_missed_diagnosis_mobile.22aab1a6.png";